// src/contexts/auth/hooks/storage.ts
/** @jsxImportSource @emotion/react */

import { ENVIRONMENT } from "../../../env";

export type AuthLogger = {
    log: (...args: any[]) => void;
    warn: (...args: any[]) => void;
    error: (...args: any[]) => void;
};

const _loggerCache = new Map<string, AuthLogger>();

export const makeAuthLogger = (scope: string): AuthLogger => {
    const cached = _loggerCache.get(scope);
    if (cached) return cached;

    const enabled = ENVIRONMENT === "DEV";
    const prefix = `[Auth][${scope}]`;

    const log: AuthLogger["log"] = (...args) => {
        if (!enabled) return;
        // eslint-disable-next-line no-console
        console.log(prefix, ...args);
    };

    const warn: AuthLogger["warn"] = (...args) => {
        if (!enabled) return;
        // eslint-disable-next-line no-console
        console.warn(prefix, ...args);
    };

    const error: AuthLogger["error"] = (...args) => {
        if (!enabled) return;
        // eslint-disable-next-line no-console
        console.error(prefix, ...args);
    };

    const logger: AuthLogger = { log, warn, error };
    _loggerCache.set(scope, logger);

    return logger;
};
